
module.directive('loginOverlay', function(authService, Principal) {
    return {
        restrict: 'E',
        templateUrl: 'page/loginOverlay',
        scope: {},
        link: function(scope, element) {

            scope.credentials = {};
            scope.visible = false;

            scope.$on('event:auth-loginRequired', function() {
                scope.visible = true;
                scope.credentials = {};
            });

            scope.login = function(username, password) {
                Principal.login(username, password).then(function(user) {
                    authService.loginConfirmed();
                    scope.visible = false;
                }, function(message) {
                    scope.message = message;
                });
            };
        }
    };
});